import {Box, BoxProps, Typography} from '@mui/material';
import {SyntheticEvent} from 'react';

interface EmptyStateProps extends BoxProps {
  text?: string;
  onAddClick?: (e: SyntheticEvent) => void;
}

export default function FieldEmptyState({
  text = '',
  onAddClick,
}: EmptyStateProps) {
  return (
    <Box display={'flex'}>
      <Typography
        sx={{
          fontSize: 12,
          fontStyle: 'italic',
          fontWeight: 400,
          color: 'text.secondary',
        }}
      >
        {text.length ? text : 'Not filled'}
      </Typography>
      {onAddClick && (
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 500,
            color: 'primary.main',
            cursor: 'pointer',
          }}
          onClick={onAddClick}
        >
          &nbsp;{'(Add)'}
        </Typography>
      )}
    </Box>
  );
}
